import { t } from "@lingui/macro";
import { useMutation } from "@tanstack/react-query";

import { toast } from "@/client/hooks/use-toast";
import { axios } from "@/client/libs/axios";
import { queryClient } from "@/client/libs/query-client";
import { useResumeStore } from "@/client/stores/resume";

import { pollDownload } from "./download-poll";
import { debouncedUpdateResume, updateResume } from "./update";

export const printResume = async (data: { id: string }) => {
  const current = useResumeStore.getState().resume;
  const snapshot = current.id === data.id ? structuredClone(current.data) : undefined;
  if (snapshot) {
    debouncedUpdateResume.cancel();
    await updateResume({ id: data.id, data: snapshot });
  }
  const response = snapshot
    ? await axios.post<{ downloadId: string }>(`/resume/print/${data.id}`, { data: snapshot })
    : await axios.get<{ downloadId: string }>(`/resume/print/${data.id}`);
  return pollDownload(response.data.downloadId);
};

export const usePrintResume = () => {
  const {
    error,
    isPending: loading,
    mutateAsync: printResumeFn,
  } = useMutation({
    mutationFn: printResume,
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ["balance-credit"] });
      void queryClient.invalidateQueries({
        queryKey: ["user-space", "account-overview"],
      });
    },
    onError: (error) => {
      toast({
        variant: "error",
        title: t`Oops, the server returned an error.`,
        description: error.message,
      });
    },
  });

  return { printResume: printResumeFn, loading, error };
};
